import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';
import { isContainedWithinMediaWrapper } from '../media-wrapper/vc-utils';
import { EditorLnvHandler } from './editor-lnv';
import { SSRPlaceholderHandlers } from './ssr-placeholders';
var state = {
  normal: 1,
  waitingForFirstRender: 2,
  ignoring: 3
};
export var Observers = /*#__PURE__*/function () {
  function Observers(opts) {
    var _this = this;
    _classCallCheck(this, Observers);
    _defineProperty(this, "observedMutations", new WeakMap());
    _defineProperty(this, "elementsInView", new Set());
    _defineProperty(this, "callbacks", new Set());
    _defineProperty(this, "totalTime", 0);
    _defineProperty(this, "_startMeasureTimestamp", -1);
    _defineProperty(this, "ssr", {
      state: state.normal,
      reactRootElement: null,
      renderStart: -1,
      renderStop: -1
    });
    _defineProperty(this, "selectorConfig", {
      id: false,
      testId: false,
      role: false,
      className: true,
      dataVC: true
    });
    _defineProperty(this, "subscribeResults", function (cb) {
      _this.callbacks.add(cb);
    });
    _defineProperty(this, "observeElement", function (node, mutation, type, ignoreReason) {
      var _this$intersectionObs;
      (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
      _this.observedMutations.set(node, {
        mutation: mutation,
        ignoreReason: ignoreReason,
        type: type
      });
    });
    this.selectorConfig = _objectSpread(_objectSpread({}, this.selectorConfig), opts.selectorConfig);
    this.intersectionObserver = this.getIntersectionObserver();
    this.mutationObserver = this.getMutationObserver();
    this.ssrPlaceholderHandler = new SSRPlaceholderHandlers();
    this.editorLnvHandler = new EditorLnvHandler();
  }
  _createClass(Observers, [{
    key: "isBrowserSupported",
    value: function isBrowserSupported() {
      return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
  }, {
    key: "observe",
    value: function observe() {
      var _this$mutationObserve;
      this.totalTime = 0;
      this.ssr = {
        state: state.normal,
        reactRootElement: null,
        renderStart: -1,
        renderStop: -1
      };
      (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
        attributeFilter: ['hidden', 'style', 'src'],
        attributeOldValue: true,
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this$mutationObserve2, _this$intersectionObs2;
      (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
      (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.disconnect();
      this.observedMutations = new WeakMap();
      this.elementsInView = new Set();
      this.callbacks = new Set();
      this.ssr.reactRootElement = null;
      this.ssrPlaceholderHandler.clear();
      this.editorLnvHandler.clear();
    }
  }, {
    key: "getTotalTime",
    value: function getTotalTime() {
      return this.totalTime;
    }
  }, {
    key: "setReactRootElement",
    value: function setReactRootElement(element) {
      this.ssr.reactRootElement = element;
    }
  }, {
    key: "setReactRootRenderStart",
    value: function setReactRootRenderStart() {
      var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
      this.ssr.renderStart = startTime;
      this.ssr.state = state.waitingForFirstRender;
    }
  }, {
    key: "setReactRootRenderStop",
    value: function setReactRootRenderStop() {
      var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
      this.ssr.renderStop = stopTime;
    }
  }, {
    key: "getMutationObserver",
    value: function getMutationObserver() {
      var _this2 = this;
      return this.isBrowserSupported() ? new MutationObserver(function (mutations) {
        _this2.measureStart();
        mutations.forEach(function (mutation) {
          // patching element if timestamp not automatically added
          // eslint-disable-next-line no-param-reassign
          mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
          var ignoreReason = '';
          if (_this2.ssr.state === state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
            _this2.ssr.state = state.ignoring;
            if (_this2.ssr.renderStop === -1) {
              // arbitrary 500ms DOM update window
              _this2.ssr.renderStop = mutation.timestamp + 500;
            }
            ignoreReason = 'ssr-hydration';
          }
          if (_this2.ssr.state === state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
            if (mutation.timestamp <= _this2.ssr.renderStop) {
              ignoreReason = 'ssr-hydration';
            } else {
              _this2.ssr.state = state.normal;
            }
          }
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function (node) {
              if (isContainedWithinMediaWrapper(node)) {
                ignoreReason = 'image';
              }
              if (node instanceof HTMLElement
              /* && !node instanceof HTMLStyleElement && !node instanceof HTMLScriptElement && !node instanceof HTMLLinkElement */) {
                if (_this2.ssrPlaceholderHandler.isPlaceholder(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                  _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function (result) {
                    if (result === false) {
                      _this2.observeElement(node, mutation, 'html', ignoreReason);
                    }
                  });
                  return;
                }
                if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                  _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function (result) {
                    if (result === false) {
                      _this2.observeElement(node, mutation, 'html', ignoreReason);
                    }
                  });
                  return;
                }
                if (fg('platform_editor_ed-25557_lnv_add_ssr_placeholder')) {
                  if (_this2.editorLnvHandler.shouldHandleAddedNode(node)) {
                    _this2.editorLnvHandler.handleAddedNode(node).then(function (_ref) {
                      var shouldIgnore = _ref.shouldIgnore;
                      _this2.observeElement(node, mutation, 'html', shouldIgnore ? 'editor-lazy-node-view' : ignoreReason);
                    });
                    return;
                  }
                }
                _this2.observeElement(node, mutation, 'html', ignoreReason);
              }
              if (node instanceof Text && node.parentElement != null) {
                _this2.observeElement(node.parentElement, mutation, 'text', ignoreReason);
              }
            });
            mutation.removedNodes.forEach(function (node) {
              if (node instanceof Element) {
                var _this2$intersectionOb;
                _this2.elementsInView.delete(node);
                (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
              }
            });
          } else if (mutation.type === 'attributes') {
            if (mutation.target instanceof HTMLElement) {
              // Commenting the following line temporarily.
              // this.observeElement(mutation.target, mutation, 'attr', ignoreReason);

              // using the if below to collect data
              // how would VC90 changes if only style display changes are accounted for
              if (mutation.attributeName === 'style' && _this2.getStyleDisplay(mutation.target.getAttribute('style')) !== _this2.getStyleDisplay(mutation.oldValue)) {
                _this2.observeElement(mutation.target, mutation, 'attr', ignoreReason);
              }
            }
          }
        });
        _this2.measureStop();
      }) : null;
    }
  }, {
    key: "getStyleDisplay",
    value: function getStyleDisplay(styleAttributeValue) {
      if (!styleAttributeValue) {
        return undefined;
      }

      // Split the style string into individual declarations
      var declarations = styleAttributeValue.split(';');
      // Iterate over each declaration
      var _iterator = _createForOfIteratorHelper(declarations),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var declaration = _step.value;
          // Trim whitespace and split into property and value
          var _declaration$split$ma = declaration.split(':').map(function (part) {
              return part.trim();
            }),
            _declaration$split$ma2 = _slicedToArray(_declaration$split$ma, 2),
            property = _declaration$split$ma2[0],
            value = _declaration$split$ma2[1];
          // Check if the property is 'display'
          if (property && property.toLowerCase() === 'display') {
            return value;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return undefined;
    }
  }, {
    key: "getElementName",
    value: function getElementName(element) {
      try {
        var tagName = element.localName;
        var dataVCAttr = element.getAttribute('data-vc');
        var dataVC = this.selectorConfig.dataVC && dataVCAttr ? "[data-vc=\"".concat(dataVCAttr, "\"]") : '';
        var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : '';
        var testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
        testId = testId ? "[testid=".concat(testId, "]") : '';
        var role = this.selectorConfig.role ? element.getAttribute('role') : '';
        role = role ? "[role=".concat(role, "]") : '';
        var classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
        classList = classList === '' ? '' : ".".concat(classList);
        var attrs = dataVC ? dataVC : [id, testId, role].join('');
        var idString = '';
        if (attrs === '' && classList === '') {
          var parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
          idString = "".concat(parent, " > ").concat(tagName);
        } else {
          idString = [tagName, attrs || classList].join('');
        }
        return idString;
      } catch (e) {
        return 'error';
      }
    }
  }, {
    key: "getIntersectionObserver",
    value: function getIntersectionObserver() {
      var _this3 = this;
      return this.isBrowserSupported() ? new IntersectionObserver(function (entries) {
        _this3.measureStart();
        entries.forEach(function (_ref2) {
          var isIntersecting = _ref2.isIntersecting,
            ir = _ref2.intersectionRect,
            target = _ref2.target;
          var data = _this3.observedMutations.get(target);
          _this3.observedMutations.delete(target);
          if (isIntersecting && ir.width > 0 && ir.height > 0) {
            if (!(target instanceof HTMLElement)) {
              return;
            }
            if (!(data !== null && data !== void 0 && data.mutation)) {
              // ignore intersection report without recent mutation
              return;
            }
            _this3.callbacks.forEach(function (callback) {
              var elementName;
              try {
                elementName = _this3.getElementName(target);
              } catch (e) {
                elementName = 'error';
              }
              callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason);
            });
            _this3.elementsInView.add(target);
          } else {
            _this3.elementsInView.delete(target);
          }
        });
        _this3.measureStop();
      }) : null;
    }
  }, {
    key: "measureStart",
    value: function measureStart() {
      this._startMeasureTimestamp = performance.now();
    }
  }, {
    key: "measureStop",
    value: function measureStop() {
      if (this._startMeasureTimestamp === -1) {
        return;
      }
      this.totalTime += performance.now() - this._startMeasureTimestamp;
      this._startMeasureTimestamp = -1;
    }
  }]);
  return Observers;
}();